<div *ngIf="successMessage" class="alert alert-success" role="alert">
    <mat-icon>thumb_up</mat-icon> &nbsp;
    <label style="vertical-align: text-bottom; margin-bottom: 0rem;">
        {{successMessage}}
    </label>
</div>
<div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    <label style="vertical-align: text-bottom; margin-bottom: 0rem;">
        {{errorMessage}}
    </label>
</div>
<div class="row_1">
    <div class="top_grid_agg">
        <div class="content1">
            <div style="width: 70%; justify-content: left; display: flex;">
                <div class="constant">
                    <label class="catlabel"> Select KPI </label>
                    <span class="content">
                        <select class="template" [(ngModel)]="page" (change)="display()">
                            <option value="By Region">By Region </option>
                            <option value="By Task"> By Task </option>
                            <option value="By Late Reason"> By Late Reason </option>
                        </select>
                    </span>
                </div>
                <div class="inline" *ngIf="enableByRegionGrid">
                    <img src="../../../assets/images/Line 8225.svg" class="line">
                    <label class="catlabel"> Period </label>
                    <span class="content">
                        <select class="template" [(ngModel)]="byRegionPeriod" (change)="displayTableContent()">
                            <option *ngFor="let period of periodData" [value]="period.periodId">
                                {{period.name}} {{period.year}}
                            </option>
                        </select>
                    </span>
                    <label class="catlabel"> Total : {{rowCount}} </label>
                </div>
                <div class="inline" *ngIf="enableByTaskGrid">
                    <img src="../../../assets/images/Line 8225.svg" class="line">
                    <label class="catlabel"> Period </label>
                    <span class="content">
                        <select class="template" [(ngModel)]="byTaskFromPeriod" (change)="displayTableContent()">
                            <option *ngFor="let period of periodData" [value]="period.periodId">
                                {{period.name}} {{period.year}}
                            </option>
                        </select>
                    </span>
                    <label class="catlabel"> TO </label>
                    <span class="content">
                        <select class="template" [(ngModel)]="byTaskToPeriod" (change)="displayTableContent()">
                            <option *ngFor="let period of periodData" [value]="period.periodId">
                                {{period.name}} {{period.year}}
                            </option>
                        </select>
                    </span>
                    <label class="catlabel"> Total : {{rowCount}} </label>
                </div>
                <div class="inline" *ngIf="enableLateReasonGrid">
                    <img src="../../../assets/images/Line 8225.svg" class="line">
                    <label class="catlabel"> Period </label>
                    <span class="content">
                        <select class="template" [(ngModel)]="byLateReasonFromPeriod" (change)="displayTableContent()">
                            <option *ngFor="let period of periodData" [value]="period.periodId">
                                {{period.name}} {{period.year}}
                            </option>
                        </select>
                    </span>
                    <label class="catlabel"> TO </label>
                    <span class="content">
                        <select class="template" [(ngModel)]="byLateReasonToPeriod" (change)="displayTableContent()">
                            <option *ngFor="let period of periodData" [value]="period.periodId">
                                {{period.name}} {{period.year}}
                            </option>
                        </select>
                    </span>
                </div>
            </div>
            <div style="width: 30%; justify-content: right; display: flex;">
                <div class="exportDiv" *ngIf="enableByTaskGrid || enableByRegionGrid">
                    <button class="refresh_button" (click)="refreshData()">REFRESH</button>
                    <button class="export_button" (click)="onBtExport()">EXPORT</button>
                </div>
            </div>
        </div>
        <div class="grid-agg" *ngIf="enableByTaskGrid || enableByRegionGrid">
            <ag-grid-angular #agGrid [ngStyle]="{'height': dynamicHeight + 'px',
            'width':'100%' }" id="kpi-Grid" class="ag-theme-balham" [pagination]="setPagination"
                [columnDefs]="columnDefs" [rowData]="rowData" [icons]="icons" [defaultColDef]="defaultColDef"
                [paginationPageSize]="paginationPageSize" [suppressCellSelection]="true" [theme]="'legacy'"
                (gridReady)="onGridReady($event)" (window:resize)="sizeToFit()" [context]="context" [icons]="icons"
                [enableCellTextSelection]="true" [ensureDomOrder]="true">
            </ag-grid-angular>
            <div class="custom-pagination" *ngIf="totalRecords > 0">
				<div class="left">
					<span class="records-per-page">
						<span>Records/Page : </span>
						<select [(ngModel)]="rpPage" (change)="rppChanged($event)">
							<option *ngFor="let size of pgDropDown" [value]="size.value">{{ size.value }}</option>
						</select>
					</span>
				</div>
				<div class="right">
					<span class="viewing-records">
						<span class="w-600">{{sRecord}}</span> to <span class="w-600">{{eRecord}}</span> of <span
							class="w-600">{{totalRecords}}</span>
						<button (click)="goToFirstPage()" [disabled]="getCurrentPage() === true"><i
								class="fa-solid fa-backward-fast"
								[ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
						<button (click)="goToPreviousPage()" [disabled]="getCurrentPage() === true"><i
								class="fa-solid fa-backward-step"
								[ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
						<span>Page <span class="w-600">{{cPage}}</span> of <span class="w-600">{{tPage}}</span></span>
						<button (click)="goToNextPage()" [disabled]="isLastPage() === true"><i class="fa-solid fa-forward-step"
								[ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
						<button (click)="goToLastPage()" [disabled]="isLastPage() === true"><i class="fa-solid fa-forward-fast"
								[ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
					</span>
				</div>
			</div>
        </div>
        <!-- KPI By Late Reason -->
        <div class="grid-agg" *ngIf="enableLateReasonGrid" class="row col-12"
            [ngStyle]="{'height': dynamicHeightCard + 'px'}">
            <div class="container">
                <div class="row" [ngStyle]="{'height': dynamicHeightTable + 'px'}">
                    <div class="col-6" style="position:relative;padding-left:0px;z-index: 100;">
                        <header class="header-1">
                            <label class="total-task">
                                &nbsp; &nbsp; Total Tasks : {{totalTasks}} &nbsp; &nbsp; Late Task : {{lateTasks}}
                            </label>
                        </header>
                        <body class="table1">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <!-- header -->
                                        <th class="tableHeaderDesc">
                                            DESCRIPTION
                                        </th>
                                        <th class="tableHeader">
                                            TASK
                                        </th>
                                        <th class="tableHeader" colspan="3">
                                            PERCENTAGE BY TIER
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let data of displayTable" [ngClass]="data.class">
                                        <td [ngClass]="data.descClass">
                                            {{data.description}}
                                        </td>
                                        <td class="task">
                                            {{data.total}}
                                        </td>
                                        <td class="per1">
                                            {{data.per1}}
                                        </td>
                                        <td class="per2">
                                            {{data.per2}}
                                        </td>
                                        <td class="per3">
                                            {{data.per3}}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </body>
                    </div>
                    <div class="col-6" style="position:relative;left:0px;">
                        <header class="header-2">
                            <label class="total-reason">
                                &nbsp; &nbsp; Total Other Reasons : {{otherReasons}}
                            </label>
                        </header>
                        <body class="table2">
                            <table class="table">
                                <tr>
                                    <th class="tableHeaderDesc">
                                        DESCRIPTION
                                    </th>
                                    <th class="tableHeader">
                                        TOTAL
                                    </th>
                                </tr>
                                <tr *ngFor="let data of secondDisplayTable" [ngClass]="data.class">
                                    <td [ngClass]="data.descClass">
                                        {{data.description}}
                                    </td>
                                    <td class="total">
                                        {{data.total}}
                                    </td>
                            </table>
                        </body>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>